/**
 * 💳 Payment Domain API Custom Axios Instance
 * shared/auth-core 통합 버전 - 결제 서버 전용
 *
 * 주의: Payment API는 인증 토큰이 필수입니다
 */

import type { AxiosRequestConfig, RawAxiosRequestConfig } from 'axios';
import { createOrvalCustomInstance } from '@edusense/shared-auth-core';

const REPEAT_QUERY_ARRAYS: NonNullable<AxiosRequestConfig['paramsSerializer']> = {
  indexes: null,
};

// Payment API 베이스 URL (환경별 설정)
const getPaymentApiBaseUrl = (): string => {
  // Payment API는 항상 pay.ugot.uk 사용
  return process.env.VITE_PAY_URL || process.env.PAYMENT_API_BASE_URL || 'https://pay.ugot.uk';
};

// Payment 클라이언트 기본 설정
const DEFAULT_PAYMENT_CONFIG = {
  timeout: 30000,
  withCredentials: true,
  enableDebug: process.env.NODE_ENV === 'development',
} as const;

// Payment 도메인용 커스텀 인스턴스 생성 (Orval mutator pattern)
const paymentApiClientImpl = createOrvalCustomInstance(
  getPaymentApiBaseUrl(),
  {
    ...DEFAULT_PAYMENT_CONFIG,
    onAuthError: () => {
      console.error('💳 Payment API 인증 실패 - 로그인 필요');
      if (typeof window !== 'undefined') {
        window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
      }
    },
  }
);

export function customInstance<T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
) {
  return paymentApiClientImpl<T>(config, {
    ...options,
    paramsSerializer: options?.paramsSerializer ?? REPEAT_QUERY_ARRAYS,
  });
}

export type ErrorType<T> = import('@edusense/shared-auth-core').AuthAxiosError<T>;
